import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: [_vm.$enum.finance.RechargeResultStatus.ORIGINAL, _vm.$enum.finance.RechargeResultStatus.PROCESSING].indexOf(_vm.status) > -1,
      expression: "[$enum.finance.RechargeResultStatus.ORIGINAL, $enum.finance.RechargeResultStatus.PROCESSING].indexOf(status) > -1"
    }],
    staticClass: "message-box"
  }, [_c('div', {
    staticClass: "icon-item "
  }, [_c('a-icon', {
    attrs: {
      "type": "loading"
    }
  })], 1), _c('div', {
    staticClass: "message-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('PingPong线上支付流程')))]), _c('p', [_vm._v(_vm._s(_vm.t('正在处理数据，请稍后...')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.status === _vm.$enum.finance.RechargeResultStatus.ERROR,
      expression: "status === $enum.finance.RechargeResultStatus.ERROR"
    }],
    staticClass: "message-box"
  }, [_c('div', {
    staticClass: "icon-item message-error"
  }, [_c('a-icon', {
    attrs: {
      "type": "close-circle",
      "theme": "filled"
    }
  })], 1), _c('div', {
    staticClass: "message-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('PingPong线上支付流程')))]), _c('p', [_vm._v(_vm._s(_vm.t('无效报文数据')))])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.status === _vm.$enum.finance.RechargeResultStatus.SUCCESS,
      expression: "status === $enum.finance.RechargeResultStatus.SUCCESS"
    }],
    staticClass: "message-box"
  }, [_c('div', {
    staticClass: "icon-item message-info"
  }, [_c('a-icon', {
    attrs: {
      "type": "info-circle",
      "theme": "filled"
    }
  })], 1), _c('div', {
    staticClass: "message-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('PingPong线上支付流程')))]), _c('p', [_vm._v(_vm._s(_vm.t('数据处理成功，但支付等待页面已关闭，请前往[充值明细]确认最终支付结果，处理后续流程')))]), _c('div', [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "data-permission": "callback_pingpong_TopUpRecordPage",
      "id": "callback_pingpong_TopUpRecordPage",
      "fbu-analyse-name": $t("\u6253\u5F00[\u5145\u503C\u660E\u7EC6]\u5217\u8868")
    },
    on: {
      "click": function ($event) {
        _vm.$router.push({
          name: 'TopUpRecordPage',
          params: {
            noCache: String(_vm.$enum.common.Enabled.YES)
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t('打开[充值明细]列表')))])], 1)])])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };